import PageTransition from "@/components/site/PageTransition";
import PageHero from "@/components/site/PageHero";
import About from "@/components/site/About";
import WorkHistory from "@/components/site/WorkHistory";

export default function AboutPage() {
    return (
        <PageTransition>
            <PageHero
                crumbs={[{ label: "Home", to: "/" }, { label: "About" }]}
                eyebrow="The Studio · Since 2013"
                title="Founder led, built on {gold:a decade} of brand craft."
                intro="Pranto.Gfx is a solo-led branding studio. Every identity is directed personally, from first concept to final system, for businesses that want to look unmistakably premium."
                tone="warm"
            />
            <About />
            <WorkHistory />
        </PageTransition>
    );
}
